import { featureRoute } from '../../../../src/routes/helpers';
import { CompensationPages } from '../../../../src/constants/AppConstants';

export default featureRoute('enableCompensationNonSeason', CompensationPages.NON_SEASON, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/compensation/NonSeason').default);
        }, 'compensation-non-season');
    }
});
